/*
 * buecherglanz — 2026-09-19
 * Grund: Design-Paket „Maison buecherglanz“ – mitlaufender Kaufbutton auf dem Handy (siehe snippets/bg-sticky-atc.liquid).
 * Funktion: zeigt die Leiste, solange der echte Kaufbutton der Hauptsektion nicht im Bild ist – also sowohl bevor man ihn
 *   erreicht (kleine Handys) als auch nachdem man an ihm vorbeigescrollt ist – und blendet sie aus, sobald er sichtbar ist.
 *   Ein Klick löst den echten Button aus (Variantenwahl, Pflichtprüfung, Warenkorb bleiben unverändert).
 *   Preis und verfügbarer Zustand werden bei Variantenwechsel aus der echten Preisanzeige übernommen.
 * Ohne Abhängigkeiten, lädt mit defer. Rückbau: Block „Kaufbutton-Leiste“ in templates/product.json deaktivieren.
 *
 * buecherglanz — 2026-09-23
 * Grund: Die Sichtbarkeit hing allein am IntersectionObserver. Der feuert nicht, solange die Seite nicht
 *   gezeichnet wird (Tab im Hintergrund, minimiertes Fenster, gedrosselte Geräte) – die Leiste blieb dann
 *   unsichtbar, obwohl der Kaufbutton längst weggescrollt war. Genau dieser Fall ist bei der Abnahme aufgetreten.
 * Funktion: zweiter, unabhängiger Weg über die Position des echten Buttons (getBoundingClientRect) bei
 *   scroll/resize, auf 100 ms gedrosselt und passiv registriert. Der Observer bleibt als sparsamer Hauptweg.
 *   Beide schreiben denselben Zustand, doppelte Aufrufe sind unschädlich.
 *
 * buecherglanz — 2026-10-01
 * Grund: Gesamtprüfung 2 (U1) – bei Produkten mit Pflicht-Auswahl (E-Reader Inserts, Sets mit Insert) blieb die Leiste
 *   auch nach der Modellwahl bei „Variante wählen“ und scrollte nur nach oben.
 * Funktion: Solange im Auswahlfeld [data-bg-select] nichts gewählt ist, zeigt die Leiste „Modell wählen“ und führt
 *   zum Feld. Sobald ein Modell gewählt ist, übernimmt sie Text und Verhalten des echten Kaufbuttons.
 */
(function () {
  const bar = document.querySelector('[data-bg-sticky-atc]');
  if (!bar) return;

  const getReal = () => document.querySelector('[id^="ProductSubmitButton-"][id$="__main"]');
  if (!getReal()) {
    bar.remove();
    return;
  }

  const button = bar.querySelector('[data-bg-sticky-button]');
  const priceOut = bar.querySelector('[data-bg-sticky-price]');
  const mode = bar.dataset.bgMode;
  const chooseLabel = bar.dataset.bgLabelChoose;
  const getSelect = () => document.querySelector('[id^="ProductInfo-"][id$="__main"] [data-bg-select]');
  // true = Pflicht-Auswahl (Modell) fehlt noch
  const needsChoice = () => {
    if (mode !== 'scroll') return false;
    const select = getSelect();
    return Boolean(select && !select.value);
  };
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  // an <body> hängen: Vorfahren mit transform (Einblend-Animationen) würden position: fixed sonst verfälschen
  document.body.appendChild(bar);
  bar.hidden = false;

  const setVisible = (visible) => {
    if (bar.classList.contains('is-visible') === visible) return;
    bar.classList.toggle('is-visible', visible);
    if (visible) {
      bar.removeAttribute('inert');
      bar.removeAttribute('aria-hidden');
    } else {
      bar.setAttribute('inert', '');
      bar.setAttribute('aria-hidden', 'true');
    }
  };

  let observed = null;
  const observer = new IntersectionObserver(([entry]) => {
    setVisible(!entry.isIntersecting);
  });
  const observe = () => {
    const real = getReal();
    if (real && real !== observed) {
      if (observed) observer.unobserve(observed);
      observer.observe(real);
      observed = real;
    }
  };

  // Zweiter Weg, unabhängig vom Zeichnen der Seite
  const checkByPosition = () => {
    const real = getReal();
    if (!real) return;
    const box = real.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const inView = box.bottom > 0 && box.top < viewportHeight;
    setVisible(!inView);
  };

  let lastCheck = 0;
  const onScroll = () => {
    const now = Date.now();
    if (now - lastCheck < 100) return;
    lastCheck = now;
    checkByPosition();
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  const sync = () => {
    observe();
    const real = getReal();
    if (!real) return;
    button.disabled = real.disabled;
    if (needsChoice() && !real.disabled && chooseLabel) {
      button.textContent = chooseLabel;
    } else {
      const label = real.querySelector('span');
      if (label && label.textContent.trim()) button.textContent = label.textContent.trim();
    }
    const price = document.querySelector('[id^="price-"][id$="__main"] .price');
    if (price) {
      const current = price.classList.contains('price--on-sale')
        ? price.querySelector('.price__sale .price-item--last')
        : price.querySelector('.price__regular .price-item--regular');
      if (current && current.textContent.trim()) priceOut.textContent = current.textContent.trim();
    }
    checkByPosition();
  };

  button.addEventListener('click', () => {
    if (needsChoice()) {
      const select = getSelect();
      select.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'center' });
      select.focus({ preventScroll: true });
      return;
    }
    const real = getReal();
    if (real && !real.disabled) real.click();
  });

  if (mode === 'scroll') {
    document.addEventListener('change', (event) => {
      if (event.target === getSelect()) sync();
    });
  }

  // PUB_SUB_EVENTS ist in constants.js als globale const deklariert (kein window-Property)
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(sync, 60));
  }

  sync();
})();
